import { FETCH_SPECIALTY_REQUEST } from "./constants";
import { combineReducers } from "redux";
import { Specialty } from "../types";
import { Action } from "./types";
import { getFailureActionType, getSuccessActionType } from "../utils";

function item(state: Partial<Specialty> = {}, action: Action): Partial<Specialty> {
  switch (action.type) {
    case getSuccessActionType(FETCH_SPECIALTY_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_SPECIALTY_REQUEST:
      return true;

    case getSuccessActionType(FETCH_SPECIALTY_REQUEST):
    case getFailureActionType(FETCH_SPECIALTY_REQUEST):
      return false;

    default:
      return state;
  }
}

export const specialty = combineReducers({ item, isFetching });
